
export default [
    {
        path: '/eduQrAtndList',
        name: 'edu-qr-atnd-list',
        component: () => import(/*webpackChunkName: "EduQr"*/ '@/views/eduqr/EduQrAtndList'),
        meta: {
            auth: true,
            logging: true, 
            pageName: '교육 출결 이력' 
        }
    }
]